import { planLimitsTypes } from './actionTypes'
import {
    handlePlanLimitsPopupErrorRequest,
    PlanLimitsPopupErrorPayload,
} from './types'

export const showPlanLimitsPopup = () => ({
    type: planLimitsTypes.SHOW_PLAN_LIMITS_POPUP,
})

export const hidePlanLimitsPopup = () => ({
    type: planLimitsTypes.HIDE_PLAN_LIMITS_POPUP,
})

export const handlePlanLimitsPopupError = (
    payload: PlanLimitsPopupErrorPayload,
): handlePlanLimitsPopupErrorRequest => ({
    type: planLimitsTypes.HANDLE_PLAN_LIMIT_POPUP_ERROR,
    payload,
})
